/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IMyHomeStatusInfo {
  /** Текст **/
  text: string;
  /** Код **/
  code: ECode;
}

export enum ECode {
  /** Не выбрано **/
  'NotSelected' = 'notSelected',
  /** Хочу продать **/
  'NeedSale' = 'needSale',
  /** Сдаю длительно или планирую сдавать **/
  'RentOrNeedRent' = 'rentOrNeedRent',
  /** Сдаю посуточно или планирую сдавать **/
  'DailyRentOrNeedRent' = 'dailyRentOrNeedRent',
  /** Решаю, сдавать или продавать **/
  'ThinkRentOrSale' = 'thinkRentOrSale',
  /** Прикидываю, сколько получу от продажи **/
  'WantKnowSalePrice' = 'wantKnowSalePrice',
  /** Попросили оценить **/
  'SomebodyWantKnowPrice' = 'somebodyWantKnowPrice',
  /** Инвестирую в этот объект **/
  'Investment' = 'investment',
  /** Хочу купить **/
  'WantToBuy' = 'wantToBuy',
  /** Просто интересуюсь **/
  'Other' = 'other',
}
